let swiper;

function initSwiper(isDesktop) {
  if (swiper) swiper.destroy(true, true);

  swiper = new Swiper(".mySwiper.product__swiper", {
    effect: isDesktop ? "cards" : "slide",
    grabCursor: true,
    centeredSlides: true,
    navigation: isDesktop
      ? {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      : false,
    pagination: !isDesktop
      ? {
          el: ".swiper-pagination",
          clickable: true,
        }
      : false,
    cardsEffect: isDesktop
      ? {
          rotate: true,
          perSlideRotate: 2,
          perSlideOffset: 1,
          slideShadows: false,
        }
      : {},
    breakpoints: {
      0: { slidesPerView: "auto", spaceBetween: 10, centeredSlides: false },
      768: { slidesPerView: "auto", spaceBetween: 10, centeredSlides: true },
      1025: { slidesPerView: 1, spaceBetween: 0, centeredSlides: true },
    },
    on: {
      setTranslate(swiper) {
        swiper.slides.forEach((slide) => {
          slide.style.transform = slide.style.transform.replace(
            /translate3d\(([^,]+),\s*([^,]+),\s*[^)]+\)/,
            "translate3d($1, $2, 0px)"
          );
        });
      },
    },
  });
}

const desktopQuery = window.matchMedia("(min-width: 1025px)");
initSwiper(desktopQuery.matches);
desktopQuery.addEventListener("change", (e) => initSwiper(e.matches));
